import { forwardRef } from 'react'
import {
  IconAlertTriangle,
  IconArrowLeft,
  IconArrowUp,
  IconBooks,
  IconBulb,
  IconCheck,
  IconChevronDown,
  IconChevronRight,
  IconCircle,
  IconClipboardCheck,
  IconClock,
  IconCopy,
  IconFileText,
  IconFolder,
  IconGitBranch,
  IconGitMerge,
  IconHistory,
  IconHome,
  IconInbox,
  IconInfoCircle,
  IconLayoutGrid,
  IconLayoutSidebarRightCollapse,
  IconLayoutSidebarRightExpand,
  IconLoader,
  IconLock,
  IconMenu2,
  IconMinus,
  IconPencil,
  IconPlus,
  IconQuote,
  IconRefresh,
  IconSearch,
  IconSettings,
  IconUpload,
  IconUsers,
  IconVersions,
  IconX,
  type IconProps,
  type TablerIcon,
} from '@tabler/icons-react'

export type { IconProps } from '@tabler/icons-react'

function withDefaults(Component: TablerIcon) {
  return forwardRef<SVGSVGElement, IconProps>(function Icon(props, ref) {
    return <Component ref={ref} size={16} aria-hidden="true" focusable="false" {...props} />
  })
}

export const ChevronDownIcon = withDefaults(IconChevronDown)
export const ChevronRightIcon = withDefaults(IconChevronRight)
export const ArrowLeftIcon = withDefaults(IconArrowLeft)
export const CheckIcon = withDefaults(IconCheck)
export const CopyIcon = withDefaults(IconCopy)
export const CloseIcon = withDefaults(IconX)
export const PlusIcon = withDefaults(IconPlus)
export const AlertIcon = withDefaults(IconAlertTriangle)
export const LockIcon = withDefaults(IconLock)
export const RetryIcon = withDefaults(IconRefresh)
export const HistoryIcon = withDefaults(IconHistory)
export const PencilIcon = withDefaults(IconPencil)
export const HomeIcon = withDefaults(IconHome)
export const ProductAreasIcon = withDefaults(IconLayoutGrid)
export const FolderIcon = withDefaults(IconFolder)
export const InitiativeIcon = withDefaults(IconGitBranch)
export const MemoryIcon = withDefaults(IconBooks)
export const ReviewsIcon = withDefaults(IconClipboardCheck)
export const SettingsIcon = withDefaults(IconSettings)
export const ArrowUpIcon = withDefaults(IconArrowUp)
export const UploadIcon = withDefaults(IconUpload)
export const FileIcon = withDefaults(IconFileText)
export const SearchIcon = withDefaults(IconSearch)
export const MenuIcon = withDefaults(IconMenu2)
export const CircleIcon = withDefaults(IconCircle)
export const VersionsIcon = withDefaults(IconVersions)
export const InboxIcon = withDefaults(IconInbox)
export const EvidenceIcon = withDefaults(IconQuote)
export const SignalIcon = withDefaults(IconBulb)
export const WorkspaceIcon = withDefaults(IconUsers)
export const PendingIcon = withDefaults(IconClock)
export const ProcessingIcon = withDefaults(IconLoader)
export const NotApplicableIcon = withDefaults(IconMinus)
export const MergeIcon = withDefaults(IconGitMerge)
export const InfoIcon = withDefaults(IconInfoCircle)
export const ExpandDocumentIcon = withDefaults(IconLayoutSidebarRightExpand)
export const CollapseDocumentIcon = withDefaults(IconLayoutSidebarRightCollapse)
